import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHorizontalAlignmentTop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="horizontal-alignment-top"><path d="M3.75 3.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 6.75V16.25H17.25V6.75H13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 6.75V20.25H10.25V6.75H6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHorizontalAlignmentTop;
